var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "vuesax/bold/lock"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M8.99984 13.0124C9.67501 13.0124 10.2223 12.4651 10.2223 11.7899C10.2223 11.1147 9.67501 10.5674 8.99984 10.5674C8.32468 10.5674 7.77734 11.1147 7.77734 11.7899C7.77734 12.4651 8.32468 13.0124 8.99984 13.0124Z",
    fill: "#DCDBE7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M13.71 7.1475V6.21C13.71 4.185 13.2225 1.5 9 1.5C4.7775 1.5 4.29 4.185 4.29 6.21V7.1475C2.19 7.41 1.5 8.475 1.5 11.0925V12.4875C1.5 15.5625 2.4375 16.5 5.5125 16.5H12.4875C15.5625 16.5 16.5 15.5625 16.5 12.4875V11.0925C16.5 8.475 15.81 7.41 13.71 7.1475ZM9 14.055C7.7475 14.055 6.735 13.035 6.735 11.79C6.735 10.5375 7.755 9.525 9 9.525C10.245 9.525 11.265 10.545 11.265 11.79C11.265 13.0425 10.2525 14.055 9 14.055ZM5.5125 7.08C5.4525 7.08 5.4 7.08 5.34 7.08V6.21C5.34 4.0125 5.9625 2.55 9 2.55C12.0375 2.55 12.66 4.0125 12.66 6.21V7.0875C12.6 7.0875 12.5475 7.0875 12.4875 7.0875H5.5125V7.08Z",
    fill: "#DCDBE7"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLock);
export default __webpack_public_path__ + "static/media/lock.318636288691013e00105dc5820d6bfc.svg";
export { ForwardRef as ReactComponent };